import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const BankCommodities = {
  state: {
    LOADING: false,
    ERRORMESSAGE: null,
    BANKCOMMODITIES: [],
    BANKCOMMODITIESTOTALRECORDS: 1,

    BANKCOMMODITYCOMMODITIES: [],
    BANKCOMMODITYSUPPLIER: [],
    BANKCOMMODITYPURCHASER: [],
    BANKCOMMODITY: [],

    BANKCOMMODITYSAVELOADING: false,
    BANKCOMMODITYSAVEERRORMESSAGE: null,
  },
  getters: {
    GETBANKCOMMODITYLOADING: (state) => state.LOADING,
    GETBANKCOMMODITYERRORMESSAGE: (state) => state.ERRORMESSAGE,
    GETBANKCOMMODITIES: (state) => state.BANKCOMMODITIES,
    GETBANKCOMMODITIESTOTALRECORDS: (state) =>
      state.BANKCOMMODITIESTOTALRECORDS,

    GETBANKCOMMODITYSAVELOADING: (state) => state.BANKCOMMODITYSAVELOADING,
    GETBANKCOMMODITYSAVEERRORMESSAGE: (state) =>
      state.BANKCOMMODITYSAVEERRORMESSAGE,
    GETBANKCOMMODITYSUPPLIER: (state) => state.BANKCOMMODITYSUPPLIER,
    GETBANKCOMMODITYPURCHASER: (state) => state.BANKCOMMODITYPURCHASER,
    GETBANKCOMMODITYCOMMODITIES: (state) => state.BANKCOMMODITYCOMMODITIES,
    GETBANKCOMMODITY: (state) => state.BANKCOMMODITY,
  },
  actions: {
    [ACTIONS.BANK_COMMODITIES_GETALL]: (context, url) => {
      var { commit } = context;
      commit(ACTIONS.BANK_COMMODITIES_GETALL_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Banks/GetAllBankCommodities" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(
                ACTIONS.BANK_COMMODITIES_GETALL_SUCCESS,
                data.ResponseData,
              );
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.BANK_COMMODITIES_GETALL_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.BANK_COMMODITIES_GETALL_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(
                ACTIONS.BANK_COMMODITIES_GETALL_ERROR,
                "Error " + err.status,
              );
            }
            if (err.request) {
              commit(ACTIONS.BANK_COMMODITIES_GETALL_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(
                ACTIONS.BANK_COMMODITIES_GETALL_ERROR,
                "Error " + err.message,
              );
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.BANKCOMMODITIES_GET]: (context, url) => {
      var { commit } = context;

      commit(ACTIONS.BANKCOMMODITIES_GET_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("banks/GetBankCommodity" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.BANKCOMMODITIES_GET_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.BANKCOMMODITIES_GET_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.BANKCOMMODITIES_GET_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(ACTIONS.BANKCOMMODITIES_GET_ERROR, "Error " + err.status);
            }
            if (err.request) {
              commit(ACTIONS.BANKCOMMODITIES_GET_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(ACTIONS.BANKCOMMODITIES_GET_ERROR, "Error " + err.message);
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.BANK_COMMODITY_SAVE]: (context, data) => {
      var { commit } = context;
      commit(ACTIONS.BANK_COMMODITY_SAVE_PENDING);
      return new Promise((resolve, reject) => {
        var params = new URLSearchParams();
        params.append("CommodityId", data.CommodityId);
        params.append("SupplierId", data.SupplierId);
        params.append("PurchaserId", data.PurchaserId);

        Api.post("banks/SaveBankCommodities", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.BANK_COMMODITY_SAVE_SUCCESS);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.BANK_COMMODITY_SAVE_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(
                ACTIONS.BANK_COMMODITY_SAVE_ERROR,
                "Data is not valid format.",
              );
              return resolve(res);
            } else {
              commit(ACTIONS.BANK_COMMODITY_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.BANK_COMMODITY_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.BANK_COMMODITY_SAVE_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.BANK_COMMODITY_SAVE_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.BANK_COMMODITY_SAVE_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.BANKCOMMODITIES_GET_COMMODITY]: (context, url) => {
      var { commit } = context;
      commit(ACTIONS.BANKCOMMODITIES_GET_COMMODITY_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Commodities/GetAll" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_COMMODITY_SUCCESS,
                data.ResponseData,
              );
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR,
                data.StatusMessage,
              );
            } else {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR,
                "Unknown Error",
              );
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR,
                "Error " + err.status,
              );
            }
            if (err.request) {
              commit(ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(
                ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR,
                "Error " + err.message,
              );
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.BANKCOMMODITIES_GET_PURCHASER]: (context, url) => {
      var { commit } = context;
      commit(ACTIONS.BANKCOMMODITIES_GET_PURCHASER_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Vendors/GetAllByType" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_PURCHASER_SUCCESS,
                data.ResponseData,
              );
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR,
                data.StatusMessage,
              );
            } else {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR,
                "Unknown Error",
              );
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(
                ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR,
                "Error " + err.status,
              );
            }
            if (err.request) {
              commit(ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(
                ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR,
                "Error " + err.message,
              );
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.DELETE_BANK_COMMODITY]: (context, params) => {
      context.commit(ACTIONS.DELETE_BANK_COMMODITY_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("Banks/DeleteBankCommodities", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.DELETE_BANK_COMMODITY_SUCCESS,
              ACTIONS.DELETE_BANK_COMMODITY_ERROR,
              false,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.DELETE_BANK_COMMODITY_ERROR);
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.BANK_COMMODITIES_GETALL_PENDING]: (state) => {
      state.LOADING = true;
      state.ERRORMESSAGE = null;
    },
    [ACTIONS.BANK_COMMODITIES_GETALL_SUCCESS]: (state, data) => {
      state.LOADING = false;
      state.ERRORMESSAGE = null;
      state.BANKCOMMODITIES = data.bankCommodities;
      state.BANKCOMMODITIESTOTALRECORDS = data.totalRecords;
    },
    [ACTIONS.BANK_COMMODITIES_GETALL_ERROR]: (state, MSG) => {
      state.LOADING = false;
      state.ERRORMESSAGE = MSG;
    },

    //save bank commodity

    [ACTIONS.BANK_COMMODITY_SAVE_PENDING]: (state) => {
      state.BANKCOMMODITYSAVELOADING = true;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.BANK_COMMODITY_SAVE_SUCCESS]: (state) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.BANK_COMMODITY_SAVE_SUCCESS]: (state, msg) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    },
    // commodity drop down

    [ACTIONS.BANKCOMMODITIES_GET_COMMODITY_PENDING]: (state) => {
      state.BANKCOMMODITYSAVELOADING = true;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.BANKCOMMODITIES_GET_COMMODITY_SUCCESS]: (state, data) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
      state.BANKCOMMODITYCOMMODITIES = data.commodities;
      state.BANKCOMMODITYSUPPLIER = [];
      state.BANKCOMMODITYPURCHASER = [];
    },
    [ACTIONS.BANKCOMMODITIES_GET_COMMODITY_ERROR]: (state, msg) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    },
    //supplier drop down
    // [ACTIONS.BANKCOMMODITIES_GET_SUPPLIER_PENDING]: state => {
    //   state.BANKCOMMODITYSAVELOADING = true;
    //   state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    // },
    // [ACTIONS.BANKCOMMODITIES_GET_SUPPLIER_SUCCESS]: (state, data) => {
    //   state.BANKCOMMODITYSAVELOADING = false;
    //   state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    //   state.BANKCOMMODITYSUPPLIER = data;
    // },
    // [ACTIONS.BANKCOMMODITIES_GET_SUPPLIER_ERROR]: (state, msg) => {
    //   state.BANKCOMMODITYSAVELOADING = false;
    //   state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    // },
    // purchaser drop down
    [ACTIONS.BANKCOMMODITIES_GET_PURCHASER_PENDING]: (state) => {
      state.BANKCOMMODITYSAVELOADING = true;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.BANKCOMMODITIES_GET_PURCHASER_SUCCESS]: (state, data) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
      state.BANKCOMMODITYPURCHASER = data.purchaser;
      state.BANKCOMMODITYSUPPLIER = data.supplier;
    },
    [ACTIONS.BANKCOMMODITIES_GET_PURCHASER_ERROR]: (state, msg) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    },
    //Bank Commodity get

    [ACTIONS.BANKCOMMODITIES_GET_PENDING]: (state) => {
      state.BANKCOMMODITYSAVELOADING = true;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.BANKCOMMODITIES_GET_SUCCESS]: (state, data) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
      state.BANKCOMMODITY = data.bankCommodity;
      state.BANKCOMMODITYCOMMODITIES = data.commodities;
      state.BANKCOMMODITYSUPPLIER = data.supplier;
      state.BANKCOMMODITYPURCHASER = data.purchaser;
    },
    [ACTIONS.BANKCOMMODITIES_GET_ERROR]: (state, msg) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    },
    [ACTIONS.DELETE_BANK_COMMODITY_PENDING]: (state) => {
      state.BANKCOMMODITYSAVELOADING = true;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.DELETE_BANK_COMMODITY_SUCCESS]: (state) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = null;
    },
    [ACTIONS.DELETE_BANK_COMMODITY_ERROR]: (state, msg) => {
      state.BANKCOMMODITYSAVELOADING = false;
      state.BANKCOMMODITYSAVEERRORMESSAGE = msg;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};

export default BankCommodities;
